import { InjectionToken } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApplicationId } from '../../lib';
import { RoomByRoomApiService } from './services';

export function createRoomByRoomService(config: RbrApiConfig, http: HttpClient) {
    return new RoomByRoomApiService(config, http);
}

export const RBR_API_CONFIG = new InjectionToken<RbrApiConfig>('RBR_API_CONFIG');

export interface RbrApiConfig {
    apiBaseUrl: string;
    applicationId: ApplicationId;
}
